import store from '../../store';

/**
 * Guard the self-service registration route.
 *
 * The signup entry point is controlled per-vertical by the
 * `dashboardConfig.auth.register` flag - the same flag that gates the
 * "Crie uma conta" CTA on the login page. When that flag is disabled, the
 * `/register` route must not be reachable - not even through a direct URL,
 * a refresh or a bookmark - so new leads are sent to the login page and have
 * to go through the commercial team instead.
 *
 * The dashboard config is loaded asynchronously at boot (see `main.js`) and
 * may still be `null` when the very first navigation runs. In that case we
 * await the config before deciding; otherwise a register-enabled vertical
 * could wrongly bounce a direct `/register` visit to `/login`. If the config
 * cannot be loaded we fail closed and redirect to login.
 *
 * @param {import('vue-router').Route} to
 * @param {import('vue-router').Route} from
 * @param {Function} next
 * @returns {Promise<void>}
 */
async function checkRegisterEnabled(to, from, next) {
  if (to.name !== 'Auth-Register') {
    return next();
  }

  if (!store.state.dashboard.dashboardConfig) {
    try {
      await store.dispatch('dashboard/getDashboardConfig', { domain: window.location.hostname });
    } catch (err) {
      return next({ name: 'Auth-Login' });
    }
  }

  const config = store.state.dashboard.dashboardConfig;
  const registerEnabled = Boolean(config && config.auth && config.auth.register);

  return registerEnabled ? next() : next({ name: 'Auth-Login' });
}

export default checkRegisterEnabled;
